import classNames from 'classnames'

import { ButtonProps } from './Button.schema'

import Link from '@/link/Link'
import Icon from '@/icon/Icon'
import { makeIdSafe } from '@/helpers/helpers'

const Button = (props: ButtonProps) => {
    const className = classNames(
        'button',
        props.className,
        `button--size-${props.size || 'medium'}`,
        `button--color-${props.color || 'white'}`,
        props.hideLabel && props.icon && 'button--icon',
        props.isError && 'button--error'
    )

    const analyticsName = makeIdSafe(props.analyticsName || props.label)

    const iconPosition = props.iconPosition || 'right'
    const icon = props.icon && (<Icon className='button__icon' name={props.icon} />)
    const leftIcon = iconPosition == 'left' && (icon)
    const rightIcon = iconPosition == 'right' && (icon)

    const target = props.target || (props.openInNewTab ? '_blank' : undefined)

    const label = (
        <div className={'button__inner'}>
            {leftIcon}
            {!props.hideLabel && props.label}
            {props.isPending ? <div className="h-loader on-button"/> : rightIcon}
        </div>
    )

    if (props.url) {
        return (
            <Link className={className} href={props.url as string} onClick={props.onClick} data-analytics-id={analyticsName} target={target}>
                {label}
            </Link>
        )
    }

    return (
        <button
            disabled={props.disabled}
            className={className}
            type={props.type || 'button'}
            onClick={props.onClick}
            aria-label={props.label}
            data-analytics-id={analyticsName}
        >
            {label}
        </button>
    )
}

export default Button
